/**
 * @generated SignedSource<<a7b5cdba1cf317b877dc6ed0698ab07e>>
 * @relayHash 0554abfb87b13a97ee0355f461ac59db
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0b36a3df59472780852e152fcec4d8e2577187262c3671bfd9b7df20f5b24699

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceAccessLinkReleaseStage = "DISABLED" | "EAP" | "GA" | "M1" | "M2" | "M3" | "%future added value";
export type useAccessLinkReleaseStageQuery$variables = {
  cloudId: string;
};
export type useAccessLinkReleaseStageQuery$data = {
  readonly confluence_accessLinkReleaseStage: ConfluenceAccessLinkReleaseStage | null;
};
export type useAccessLinkReleaseStageQuery = {
  response: useAccessLinkReleaseStageQuery$data;
  variables: useAccessLinkReleaseStageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "kind": "ScalarField",
    "name": "confluence_accessLinkReleaseStage"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAccessLinkReleaseStageQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAccessLinkReleaseStageQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0554abfb87b13a97ee0355f461ac59db",
    "id": "0b36a3df59472780852e152fcec4d8e2577187262c3671bfd9b7df20f5b24699",
    "metadata": {},
    "name": "useAccessLinkReleaseStageQuery",
    "operationKind": "query",
    "text": "query useAccessLinkReleaseStageQuery($cloudId:ID!){confluence_accessLinkReleaseStage(cloudId:$cloudId)}"
  }
};
})();

(node as any).hash = "ead040443f9a81caa5ae3dfcb561832d";

export default node;
